/**
 * Created by Andrey Popov on 10.11.22
 */

const Climbable = function (unit) { 
    UnitComponent.call(this, unit);
};

Climbable.prototype = Object.create(UnitComponent.prototype);
Climbable.prototype.constructor = Climbable;

Climbable.prototype.getActionInfo = function () {
    const trigger = Climbable.GetTrigger(this.unit);
    if (!trigger) {
        return;
    }

    return {
        title: {
            code: trigger.code,
            stage: trigger.stage,
            icon: true
        },
        buttons: {
            locate: {
                action: function () {
                    UnitLocator.find(Map2d.OPEN_UNIT, trigger);
                }
            }
        }
    };
};

Climbable.prototype.gotoNextStage = function (f) {
    f = f || function () {};

    if (this.climbed || this.unit.isLast()) {
        f();
        return;
    }
    this.climbed = true;
    this.unit.movable = false;

    const newUnit = new Unit({
        code: this.unit.code,
        stage: this.unit.stage + 1
    });

    const replace = function () {
        this.unit.takePrizes();
        this.unit.remove(true);

        newUnit.setPosition(this.unit.x, this.unit.y);
        Map2d.currentMap.onAddUnit(newUnit.x, newUnit.y, newUnit);
        Map2d.currentMap.onUnitAvailable(newUnit);
        Map2dLocation.currentLocation.counter.setTimeout(Map2d.mapEvent.bind(Map2dLocation.currentLocation, Map2d.SPAWN, { unit: newUnit }), 0);

        Map2d.currentMap.blockedGrounds.updateBlockedGrounds();
    }.bind(this);

    const view = this.view;

    if (view) {
        view.beforeStageUpdate();
        replace();
        view.updateStage(newUnit, () => {
            Climbable.CheckDependantClimbers(newUnit);
            f();
        });
    } else {
        replace();
        Climbable.CheckDependantClimbers(newUnit);
        f();
    }
};

Climbable.GetTrigger = function (unit) {
    const trigger = Climbable.TRIGGERS[cleverapps.meta.selectedLocationId()];
    return trigger && trigger[Unit.GetKey(unit)];
};

Climbable.CreateCinematic = function (unit) {
    const component = unit.findComponent(Climbable);
    if (!component) {
        return;
    }

    const trigger = Climbable.GetTrigger(unit);
    if (!trigger || !Map2d.currentMap.listAvailableUnits(trigger).length) {
        return;
    }

    return function (f) {
        component.gotoNextStage(f);
    };
};

Climbable.getForwardTriggers = function () {
    const locationId = cleverapps.meta.selectedLocationId();
    const triggers = Climbable.TRIGGERS[locationId];
    if (!triggers) {
        return;
    }

    let forward = Climbable.FORWARD_TRIGGERS[locationId];
    if (!forward) {
        forward = Climbable.FORWARD_TRIGGERS[locationId] = {};

        Object.keys(triggers).forEach((dependantKey) => {
            const trigger = triggers[dependantKey];

            [Unit.ParseKey(dependantKey), trigger].forEach((unit) => {
                if (!Families[unit.code] || !Families[unit.code].units[unit.stage]) {
                    cleverapps.throwAsync(`Climbable.TRIGGERS ${locationId} refers to unknown unit ${unit.code}_${unit.stage}`);
                }
            });

            const triggerKey = Unit.GetKey(trigger);
            forward[triggerKey] = (forward[triggerKey] || []).concat(dependantKey);
        });
    }

    return forward;
};

Climbable.CheckDependantClimbers = function (newUnit) {
    const forward = Climbable.getForwardTriggers();
    if (!forward) {
        return;
    }

    const dependantKeys = forward[Unit.GetKey(newUnit)];
    if (!dependantKeys) {
        return;
    }

    dependantKeys.forEach((dependantKey) => {
        Map2d.currentMap.listAvailableUnits(Unit.ParseKey(dependantKey)).forEach((unitToChangeStage) => {
            const climbable = unitToChangeStage.findComponent(Climbable);
            if (climbable) {
                climbable.gotoNextStage();
            }
        });
    });
};

Climbable.TRIGGERS = {};
Climbable.FORWARD_TRIGGERS = {};